exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue[data-v-a4e9069e]{background:#95CCFF}.yellow[data-v-a4e9069e]{background:#FEDB00}.orange[data-v-a4e9069e]{background:#FFBF60}.mix-board .mix-title[data-v-a4e9069e]{line-height:0.15625rem;display:flex;align-items:center;justify-content:space-between}.mix-board .mix-title .title-name[data-v-a4e9069e]{box-sizing:border-box;color:#9B9B9B;font-weight:600;border-radius:0.08333rem 0 0 0.08333rem}.mix-board .mix-title .title-value[data-v-a4e9069e]{text-align:right;border-radius:0 0.08333rem 0.08333rem 0;color:#757575;font-weight:500;padding-right:0.05208rem}\n", ""]);

// exports
